import { GenericDialog } from '@/components/shared/GenericDialog';
import { abyssColors } from '@/theme/colors';
import { Button, Stack, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { showBulkCommentsDialog, isBulkCommentsUpdateRequested } from '../state/atoms';

export const BulkCommentsDialog = () => {
  const [open, setOpen] = useAtom(showBulkCommentsDialog);
  const setUpdate = useSetAtom(isBulkCommentsUpdateRequested);

  const handleContinue = useCallback(() => {
    setOpen(false);
    setUpdate(true);
  }, [setUpdate, setOpen]);

  const handleCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <GenericDialog
      open={open}
      dialogStyles={{
        '.MuiDialog-container': {
          alignItems: 'baseline',
          paddingTop: '14.8rem',
        },
      }}
      paperStyles={{
        maxWidth: '52.6rem',
      }}
      titleStyles={{
        padding: '2.4rem 2.4rem 0.8rem 2.4rem',
      }}
      onClose={() => setOpen(false)}
      title="Updating comments"
      content={
        <Stack gap="1.6rem">
          <Typography
            fontSize="1.4rem"
            color={abyssColors.primary[700]}
            lineHeight={1.43}
            letterSpacing="normal"
          >
            You are updating comments for all selected components. This action will only update
            comments, no calculations will be changed.
          </Typography>
        </Stack>
      }
      actions={
        <Stack
          gap="1.15rem"
          direction="row"
          sx={{
            '.MuiButton-root': {
              padding: '0.6rem 1.6rem',
              textTransform: 'uppercase',
              fontWeight: 500,
              lineHeight: '2.4rem',
              letterSpacing: '0.04rem',
              fontSize: '1.4rem',
            },
          }}
        >
          <Button onClick={handleCancel}>CANCEL</Button>
          <Button variant="contained" sx={{ fontWeight: 500 }} onClick={handleContinue}>
            UPDATE COMMENTS
          </Button>
        </Stack>
      }
      actionsStyles={{ mr: 3, pb: 3, pt: '1.4rem' }}
    />
  );
};
